<template>
    <footer class="footer" :class="!$store.state.clientConfig.logo.usePrimaryBg ? 'nonTransparent' : 'transparent'">
        <div class="container">
            <div class="footer-inner">
                <div class="left-content">
                    <div class="email-phone-contact">
                        <div class="email">
                            <p class="footer-heading">Email us</p>
                            <a :href="`mailto:${clientConfig.email}`" class="text-break">{{ clientConfig.email }}</a>
                        </div>
                    </div>
                </div>
                <div class="call-us">
                    <p class="footer-heading">Call us</p>
                    <div>
                        <a :href="`tel:${clientConfig.telephoneBasic}`" class="text-nowrap">{{ clientConfig.telephoneInt }}</a>
                        <p>({{ clientConfig.contact && clientConfig.contact.contactTimeRange ? clientConfig.contact.contactTimeRange : CONTACT_US_TIME_RANGE }}
                        </p>
                        <p>Monday to Friday)</p>
                    </div>
                </div>
                <div class="middle-content">
                    <img :src="`${clientConfig.directoryUrl}/img/logo.png`" :alt="$store.state.clientConfig.schemeName" />
                </div>
                <div class="write-to-us">
                    <p class="footer-heading">Write to us</p>
                    <dynamic-template :template="CONTACT_US_WINCHESTER" />
                </div>
                <div class="useful-pages">
                    <div>
                        <p class="footer-heading">Useful Pages</p>
                        <div>
                            <div v-if="!isRegistrationAndLoginDisabled"><router-link to="/my-pension/my-data">My Pension</router-link></div>
                            <div>
                                <router-link to="/information">{{ clientConfig.fundOrScheme }} Information</router-link>
                            </div>
                            <div><router-link to="/pension-news">News</router-link></div>
                            <div><router-link to="/links">Links</router-link></div>
                            <div><router-link to="/frequently-asked-questions">FAQs</router-link></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
import dynamicTemplate from 'v-runtime-template';
import CONTACT_US_TIME_RANGE from '@/constants/contactUsTimeRange';
import CONTACT_US_WINCHESTER from '@/constants/contactUsWinchester';

export default {
    name: 'footer-bar',
    components: {
        dynamicTemplate,
    },
    data () {
        return {
            CONTACT_US_TIME_RANGE,
            CONTACT_US_WINCHESTER,
        };
    },
    computed: {
        clientConfig () {
            return this.$store.state.clientConfig;
        },
        isRegistrationAndLoginDisabled () {
            return !!this.clientConfig.disableRegistrationAndLogin;
        },
    },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/_mixins.scss";

footer {
    min-height: fit-content;

    &.transparent {
        color: var(--navFont);
        background: var(--navColour);

        a {
            color: var(--navFont);
        }
    }

    &.nonTransparent {
        background: white;
        color: var(--primaryColour);
        box-shadow: $boxShadow;

        a {
            color: var(--primaryColour);
        }
    }

    .footer-inner {
        display: flex;
        padding-top: 3rem;

        @include responsive("md") {
            justify-content: space-between;
            font-size: 0.9rem;
        }

        @include responsive("sm") {
            flex-wrap: wrap;
            padding-top: 1rem;
        }

        .footer-heading {
            font-size: 1.1rem;
            font-weight: 700;
            margin-bottom: 1rem;

            @include responsive("sm") {
                margin-bottom: 0.5rem;
            }
        }

        p {
            margin-bottom: 0;
        }

        .left-content {
            @include responsive("sm") {
                width: 50%;
            }

            .email-phone-contact {
                padding-right: 2rem;

                .email {
                    margin-bottom: 2rem;
                }
            }
        }

        .middle-content {
            width: 35%;
            text-align: center;

            @include responsive("md") {
                display: none;
            }

            img {
                width: 50%;
            }
        }

        .call-us {
            @include responsive("sm") {
                width: 50%;
            }
        }

        .write-to-us {
            padding-right: 2rem;

            @include responsive("md") {
                padding-right: 0;
            }

            @include responsive("sm") {
                width: 50%;
                padding-right: 2rem;
            }
        }

        .useful-pages {
            margin-left: auto;
            text-align: center;

            @include responsive("md") {
                margin: 0;
            }

            @include responsive("sm") {
                width: 50%;
                text-align: left;
            }
        }
    }
}
</style>
